export default __webpack_public_path__ + "static/IPad_App-MockUp-6acbfe26b1984a0a28ced7162c9bf9c4.webp";